import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {GroupMember} from '../../../graphql/groups.datatypes';
import {gqlGroupMember} from '../getGroupMember.api';
import {UpdateGroupMemberInput} from './updateGroupMember.api';

interface LimitedUpdateGroupMemberData {
    __typename?: string,
    limitedUpdateGroupMember: GroupMember
}

export const LIMITED_UPDATE_GROUP_MEMBER_MUTATION = gql`
    mutation limitedUpdateGroupMember($data: UpdateGroupMemberInput!) {
        limitedUpdateGroupMember(data: $data) {
            ${gqlGroupMember}
        }
    }
`;

export const limitedUpdateGroupMember = () => useMutation<LimitedUpdateGroupMemberData, UpdateGroupMemberInput>(
  LIMITED_UPDATE_GROUP_MEMBER_MUTATION,
  {
      update: (cacheRef) => {
          updateCacheByType('GroupMember')(cacheRef);
          updateCacheByType('User')(cacheRef);
      },
  }
);

export default limitedUpdateGroupMember;